import type { FunctionalComponent, RefObject } from 'preact';
import { route } from 'preact-router';
import { formatPrice, returnUrl } from '@/lib/utils.ts';
import { useAppSelector } from '@/store/hooks.ts';

interface Props {
  /** `.title` 등 시안의 헤더 모디파이어 */
  class?: string;
  /** 히어로 화면에서 스크롤에 따라 `.is-visible` 을 토글하기 위해 넘긴다 */
  elementRef?: RefObject<HTMLElement>;
}

/**
 * 시안 공통 헤더: 로고 + 보유 포인트 + 마이페이지.
 * 비로그인이면 시안대로 로그인 버튼을 대신 보여준다.
 */
export const Header: FunctionalComponent<Props> = ({ class: className, elementRef }) => {
  const user = useAppSelector((state) => state.auth.user);
  const isLogin = !!user?.id;

  function go(e: MouseEvent, path: string) {
    e.preventDefault();
    route(path);
  }

  return (
    <header class={className} ref={elementRef}>
      <a href="/" class="logo" onClick={(e) => go(e, '/')}>
        <img src="/images/logo_b.png" alt="urnplay" />
      </a>

      {isLogin ? (
        <div class="user-info">
          <div class="my-point">{formatPrice(user?.point ?? 0)}p</div>
          <a href="/mypage" onClick={(e) => go(e, '/mypage')}>
            <div class="nav-icon">
              <img src="/images/user.png" alt="마이페이지" />
            </div>
          </a>
        </div>
      ) : (
        <a
          href="/login"
          class="nav-login-btn"
          onClick={(e) => go(e, `/login?r=${encodeURIComponent(returnUrl())}`)}
        >
          로그인
        </a>
      )}
    </header>
  );
};
